import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { GroupDescriptor, SortDescriptor, State } from '@progress/kendo-data-query';
import { ApiService } from '../service/api.service';
import { LoaderService } from '../loader/loader.service';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { APP_DATE_FORMATS } from '../service/date.adapter';
import { GridSettingsService } from '../service/grid-settings.service';

@Component({
    selector: 'app-login-log',
    templateUrl: './login-log.component.html',
    styleUrls: ['./login-log.component.css'],
    providers: [
        DatePipe,
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS,
        },
    ],
    standalone: false
})
export class LoginLogComponent implements OnInit, AfterViewInit {
  @ViewChild("grid", { static: true }) gridKendo: GridComponent;
  kendoLoading = false;
  public groups: GroupDescriptor[] = [];
  state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
    group: this.groups,
  };
  public sort: SortDescriptor[] = [];
  logData: any;
  total: 0;
  gridData: GridDataResult;
  columnList: any = [];
  searchString: any = '';
  startDate: string;
  endDate: string;
  formattedDate: string;
  DesktopCount: any;
  MobileCont: any;
  TabletCount: any;
  WebCount: any;
  AndroidCount: any;
  IosCount: any;
  PwaCount: any;
  public gridHeight: number;
  public pageableWithAll: any = {
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };
  TableName = "LoginLog";
  constructor(private api: ApiService,
    private LoaderService: LoaderService,
    public datePipe: DatePipe,
    private readonly gridSettings: GridSettingsService) { }

  ngOnInit(): void {
    this.columnList.push('Username', 'IpAddress', 'Location', 'DeviceType', 'LoginTime', 'CompanyId', 'Domain');
    const todayDate = new Date().toISOString().split('T')[0];
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
    const startDateISO = startOfMonth.toISOString().split('T')[0];
    this.startDate = startDateISO;
    this.endDate = todayDate;
    this.loadData();
    this.GetDeviceCount();
    this.setGridHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 195;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
  }

  clearList() {
    this.searchString = '';
    this.loadData();
  }
  public dataStateChange(state: any): void {
    this.state = state;
    this.loadData();
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loadData();
  }
  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.loadData();
  }
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadData();
  }
  applyFilter(): void {
    this.loadData();
  }

  GetDeviceCount(): void {
    this.api.GetDeviceCount().subscribe((res: any) => {
      if (res['Success']) {
        this.DesktopCount = res["Data"].Desktop;
        this.MobileCont = res["Data"].Mobile;
        this.TabletCount = res["Data"].Tablet;
        this.WebCount = res["Data"].Web;
        this.AndroidCount = res["Data"].Android;
        this.IosCount = res["Data"].Ios;
        this.PwaCount = res["Data"].PWA;
      }
    })
  }

  loadData(): void {
    this.LoaderService.show();
    if (this.state.filter) this.state.filter.filters = [];

    const formatLocalDate = (d: Date) => {
      const offset = d.getTimezoneOffset();
      const localDate = new Date(d.getTime() - offset * 60 * 1000);
      return localDate.toISOString().split('T')[0];
    };

    const startDate = formatLocalDate(new Date(this.startDate));
    const endDate = formatLocalDate(new Date(this.endDate));

    this.api.getAllLoginLog(this.state, JSON.stringify(this.searchString.trim()), startDate, endDate).subscribe((res: any) => {
      if (res['Success']) {
        this.logData = res["Data"];
        res['Data'].Data.forEach((e: any, i: any) => {
          const transformedDate = this.datePipe.transform(e.LoginTime, 'yyyy-MM-dd HH:mm');
          this.formattedDate = transformedDate ? transformedDate : '';
          e.LoginTime = transformedDate;
        });
        this.gridData = {
          data: res["Data"].Data,
          total: res["Data"].Total,
        };
      }
      this.LoaderService.hide();
    })

  }
  filterData(event: any) {
    this.searchString = event;
    this.state.skip = 0;
    this.state.filter = {
      logic: 'or',
      filters: [],
    };
    if (event) {
      this.state.filter.filters = this.columnList.map((field: any) => ({
        ignoreCase: true,
        value: event,
        operator: 'contains',
        field,
      }));
    }
    this.loadData();
  }

  onColumnVisibilityChange(columnEvent: GridComponent): void {
    this.gridSettings.saveGridSettings(columnEvent, this.TableName).subscribe();
  }

  ngAfterViewInit(): void {
    this.gridSettings.applyGridSettings(this.api, this.TableName, this.gridKendo);
  }
}
